import MobileWelcome from './MobileWelcome';
export default MobileWelcome;
